export enum FeatureToggle {
  ProductsViewPage = 'rt_products_view_page',
  ProductSearchCPTButton = 'rt_catalog_product_search_report_cpt_problem',
  RetailerCollectionsV2 = 'rt_retailer_collections_ux_v2',
}
